module.exports = __webpack_public_path__ + "static/carousel-amazon-3-98420fbaa1c3750f0e447dfef30fc3e8.png";